const SUPPORT_HOURS_ET = {
  days: [1, 2, 3, 4, 5],
  end: 16,
  start: 8,
} as const;

export { SUPPORT_HOURS_ET };

export function isAfterHours(date: Date): boolean {
  const parts = new Intl.DateTimeFormat("en-US", {
    hour: "2-digit",
    hour12: false,
    timeZone: "America/New_York",
    weekday: "short",
  }).formatToParts(date);

  const hour = Number(parts.find((p) => p.type === "hour")?.value ?? "0");
  const dayName = parts.find((p) => p.type === "weekday")?.value ?? "";

  const dayMap: Record<string, number> = {
    Fri: 5,
    Mon: 1,
    Sat: 6,
    Sun: 0,
    Thu: 4,
    Tue: 2,
    Wed: 3,
  };
  const day = dayMap[dayName] ?? -1;

  const withinHours =
    hour >= SUPPORT_HOURS_ET.start && hour < SUPPORT_HOURS_ET.end;
  const withinDays = (SUPPORT_HOURS_ET.days as readonly number[]).includes(day);

  return !(withinHours && withinDays);
}
